export const START_FROM_SCRATCH = '@hubspot/email/dnd/Start_from_scratch.html';
export const SYSTEM_FONT_VALUES = {
  Helvetica: 'Arial,sans-serif'
};
export const SYSTEM_FONTS_CMV2 = Object.keys(SYSTEM_FONT_VALUES).map(name => {
  return [`${name},${SYSTEM_FONT_VALUES[name]}`, name];
});
const FONT_OPTIONS = [{
  text: 'Arial',
  value: 'Arial, sans-serif'
}, {
  text: 'Courier New',
  value: "'Courier New', Courier, monospace"
}, {
  text: 'Georgia',
  value: 'Georgia, serif'
}, {
  text: 'Tahoma',
  value: 'Tahoma, sans-serif'
}, {
  text: 'Times New Roman',
  value: "'Times New Roman', Times, serif"
}, {
  text: 'Trebuchet MS',
  value: 'Trebuchet MS, sans-serif'
}, {
  text: 'Verdana',
  value: 'Verdana, sans-serif'
}, {
  text: '微軟正黑體',
  value: "'PingFang TC', 微軟正黑體, 'Microsoft JhengHei', Arial, sans-serif"
}, {
  text: '新細明體',
  value: "'Songti TC', 新細明體, PMingLiU, Times, serif"
}];
export function getFontOptions() {
  return FONT_OPTIONS;
}
export function getFontOptionsForCmv2() {
  return getFontOptions().map(({
    text,
    value
  }) => [value, text]);
}
export function getFontOptionsForTiny() {
  return getFontOptions().reduce((acc, font) => {
    acc[font.text] = font.value;
    return acc;
  }, {});
}